import type { UrgencyCodesListResponse } from './api';

export const normalizeUrgencyCodesList = (list: UrgencyCodesListResponse): { label: string; value: string }[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.codeDesc,
    value: row.codeId,
  }));
};
